<template>
    <div class="contanner search_warp">
        <div class="search_top">
            <el-select v-model="typeValue" placeholder="请选择">
                <el-option
                v-for="(item, i) in options"
                :key="i"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
            <div class="search_input_box">
                <i class="el-icon-search search_icon"></i>
                <el-input class="search_input" v-model="searchInput" placeholder="搜索你感兴趣的内容" @keyup.enter.native="onSearch"></el-input>
                <el-button @click="onSearch" type="danger" class="search_btn" round>搜索</el-button>
            </div>
        </div> 
        <div class="search_history">
            <Tag 
                class="search_his_item"
                type="info"
                v-for="(item, i) in history"
                :key="i"
                @click="getHistoy(item)"
            >{{item}}</Tag>
        </div>
        <div class="title_box">搜索结果</div>
        <div class="empty_search" v-if="!searchData.length">暂无数据</div>
        <div v-else>
            <div class="search_data_item" v-for="(item, i) in searchData" :key="i" @click="toDetail(item)">
                <div class="item_title" v-html="item.title"></div>
                <div>发布场馆：{{item.venueName}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Tag } from 'element-ui';
import { post } from '@u/request'
import { toRoute } from '@u/index'

export default {
    name: 'search',
    components: { Tag },
    data() {
        return {
            options: [
                {label:'全部',value: null},
                {label:'图文',value: 1},
                {label:'活动',value: 2},
                {label:'视频',value: 6},
            ],
            typeValue: null,
            searchInput: '',
            searchData: []
        }
    },
    computed: {
        history() {
            return this.getItem()
        }
    },
    methods: {
        toDetail(item) {
            const path = toRoute[item.type-1]+'/detail/'+item.id;
            this.$router.push(path)
        },
        getItem() {
            const str = localStorage.getItem('history');
            if (str) {
                return JSON.parse(str)
            }
            return []
        },
        getHistoy(item) {
            this.searchInput = item;
            this.load()
        },
        onSearch() {
            // 当输入的空值，或者 输入的值已经存在,不做操作
            if (!this.searchInput ) return ;
            this.load()
            let history = JSON.parse(localStorage.getItem('history'));
            if (!history) {
                history = [this.searchInput]
            } else {
                if (history.indexOf(this.searchInput) >= 0) return;
                history.push(this.searchInput)
                if (history.length > 5) {
                    history = history.splice(history.length-5,5);
                    
                } 
            }
            localStorage.setItem('history',JSON.stringify(history))
        },
        async load() {
            const params ={
                srchkey: this.searchInput,
                type: this.typeValue
            }
            const { data } = await post('resource/showapi/search',params)
            this.searchData = data.map(item => {
                item.title = item.title.replace(new RegExp(this.searchInput, 'gi'), txt => { return `<span style='color:#a80000'>${txt}</span>` });
                return item
            });
        }
    }
}
</script>

<style scoped lang="scss">
.search_warp {
    padding: 30px 20px;
    min-height: calc(100vh - 315px);
    background: #f8f8f8;
    .search_top {
        display: flex;
        align-items: center;
        .search_input_box {
            flex: 1;
            height: 50px;
            background: #eaeaea;
            border-radius: 33px;
            display: flex;
            align-items: center;
        }
        .search_icon {
            color: #999;
            font-size: 30px;
            margin-left: 20px;
        }
        .search_btn {
            font-size: 24px;
            background: #a80000;
            height: 50px;
            border: none;
            border-radius: 25px;
        }
        .search_input_box {
            ::v-deep {
                .el-input__inner {
                    height: 100%;
                    border: none;
                    font-size: 24px;
                    outline: none;
                    background-color: #eaeaea;
                    color: #000;
                }
            }
        }
        ::v-deep {
            .el-select {
                width: 200px;
                margin-right: 20px;
                .el-input__inner {
                    font-size: 24px;
                }
            }
        }
    }
    .title_box {
        font-size: 25px;
        color: #333;
        font-weight: 500;
        padding: 35px 0;
    }
    .search_history {
        padding-top: 20px;
        text-align: center;
    }
    .search_his_item {
        min-width: 90px;
        height: 40px;
        line-height: 40px;
        color: #666;
        font-size: 24px;
        text-align: center;
        margin-right: 20px;
        cursor: pointer;
        border: none;
        background: #eaeaea;
    }
    .empty_search {
        text-align: center;
        margin-top: 20px;
        color: #777;
    }
    .search_data_item {
        background: #fff;
        box-shadow: 0 0 13px 1px rgba(0,0,0,.1);
        border-radius: 5px;
        margin-bottom: 20px;
        position: relative;
        line-height: 1;
        font-size: 16px;
        padding: 20px;
        cursor: pointer;
        .item_title {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 20px;
        }
    }
}
</style>